import { createInternalNeonAuth } from '@neondatabase/auth';
import { BetterAuthReactAdapter } from '@neondatabase/auth/react/adapters';

const neonAuthUrl = import.meta.env.VITE_NEON_AUTH_URL;

const neonAuth = neonAuthUrl
  ? createInternalNeonAuth(neonAuthUrl, { adapter: BetterAuthReactAdapter() })
  : null;

export function getNeonAuthClient() {
  if (!neonAuth) {
    throw new Error('VITE_NEON_AUTH_URL belum dikonfigurasi');
  }
  return neonAuth.adapter;
}

export async function getNeonJwtToken(): Promise<string | null> {
  return neonAuth?.getJWTToken() ?? null;
}
